import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { Button } from '@gem/ui-kit';

import { useSoftUpdatePresenter } from './SoftUpdate.presenter';
import styles from './styles.m.css';

export const SoftUpdate: FC = observer(() => {
  const presenter = useSoftUpdatePresenter();
  const { t } = useTranslation();

  if (!presenter.hasSoftUpdate) {
    return null;
  }

  return (
    <Button
      theme="primary"
      className={styles.container}
      onClick={presenter.onClick}
    >
      {t('common_update_gem4me_action')}
    </Button>
  );
});
